<template lang="pug">
  .table-responsive
    table#tbDestinos.table.is-striped.is-fullwidth.is-narrow
      thead
        tr
          th.is-size-6
            | #
          th.is-size-6 
            | Nombre
          th.is-size-6 
            | Dirección
          th.is-size-6 
            | Clave
          th.is-size-6 
            | Teléfono
      tbody
        tr(v-for="(dest, index) in destinos" :key="dest.id")
          td 
            a.button.is-text(@click="editarDestino(dest.idDestinatario)") {{ index + 1 }}
          td {{ dest.nombre }}
          td {{ dest.direccion }}
          td {{ dest.clave }}
          td {{ dest.telefono }}
</template>

<script>
import { mapState } from 'vuex'
  export default {
    name: 'TbDestinos',
    props: {
      destinos: {
        type: Array,
        default: []
      },
    },
    methods: {
      editarDestino(id) {
        if( this.permisos.sca_irge == 1 || this.permisos.sca_tpa == 1 ){
          this.destinoSeleccionado = [],
          this.destinoSeleccionado = this.destinos.filter(g => g.idDestinatario == id)
          this.$emit('showFormEdit', this.destinoSeleccionado)
        } 
      }
    },
    computed: {
      ...mapState(["permisos"]),
    }
  }
</script>
<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/TbDestinos.vue